<template>
	<v-row class="ma-0" no-gutters id="refactored-invoice-tabs">
		<!-- chips -->
		<v-col cols="auto">
			<v-chip-group
				v-if="draftInvoices.length"
				v-model="activeInvoice"
				center-active
				show-arrows
				active-class="primary elevation-0 bgColor--text"
				:style="{ maxWidth: maxWidth }"
			>
				<v-chip
					v-for="(item, index) in draftInvoices"
					:key="index"
					class="rounded ma-0 me-1 px-3 justify-center error--text font-weight-bold"
					:outlined="activeInvoice !== item.id"
					:style="{ minWidth: '20px', overflow: 'hidden' }"
					:value="item.id"
					@click="
						item.id !== $route.params.id
							? $router.push({ name: $route.name, params: { id: item.id } })
							: null
					"
				>
					{{item.name}}
				</v-chip>
			</v-chip-group>
		</v-col>

		<!-- add button -->
		<v-col cols="auto" class="d-flex align-center">
			<v-btn
				min-width="0"
				height="32"
				color="grey lighten-2"
				:loading="loading"
				outlined
				:disabled="loading || disable"
				class="rounded align-self-start me-1 px-1"
				@click="
					loading = true;
					eventHub.$emit('create-invoice', data => {
						loading = false;
					}
				)"
			>
				<div class="d-flex align-center">
					<tooltip bottom :text="$t('add-invoice')">
						<v-icon size="23" color="black">mdi-plus</v-icon>
					</tooltip>

					<tooltip bottom :text="$t('drafts-count')">
						<div class="drafts-count error--text font-weight-bold" @mouseover.stop.prevent>
							{{draftInvoices.length}}
						</div>
					</tooltip>
				</div>
			</v-btn>
		</v-col>

	</v-row>
</template>

<script>
import Tooltip from '../Tooltip.vue';
export default {
	name: 'InvoicesTabs',

	props: {
		eventHub: { type: Object },
		disable: { type: Boolean }
	},

	components: {
		Tooltip
	},

	data() {
		return {
			loading: false,
			activeInvoice: null,
			draftInvoices: []
		}
	},

	watch: {
		'$route.params.id'(val) {
			if (this.$route.name === 'sale-invoice' && val) {
				this.activeInvoice = val;
			}
		}
	},

	computed: {
		maxWidth() {
			return `${this.$vuetify.breakpoint.width - (this.$vuetify.breakpoint.lgAndUp ? 1100 : 500)}px`
		}
	},

	created() {
		this.eventHub.$on('update-invoices', invoices => {
			this.draftInvoices = invoices
		})
		if (this.$route.name === 'sale-invoice' && this.$route.params.id) {
			this.activeInvoice = this.$route.params.id;
		}
	},

	beforeDestroy() {
		this.eventHub.$off('update-invoices');
	}
}
</script>

<style lang="scss">
#refactored-invoice-tabs {
	// margin-top: -8px;

	.v-slide-group__content {
		padding: 0;
	}

	.drafts-count {
		font-size: 20px;
		line-height: 30px;
	}
}
</style>